// Глобальні скрипти теми.
//
// Перенесено з концепту brand/*.html; блок перемикання мов прибрано —
// його роль виконує Polylang з окремими URL, а не підміна тексту на льоту.

(function(){
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* приховуємо тільки якщо JS живий — без нього вміст лишається видимим */
  if (!reduce) document.documentElement.classList.add('js');

  /* Скрол до секції без хеша в адресі: кнопку малює phpdev_buttons() з
     data-scroll="cta". Ціль шукаємо спершу за id, потім за класом блока
     (.phpdev-cta) — так само працює і для глобальних блоків. Відступ згори
     знімає sticky-шапку, інакше заголовок секції ховається під нею. */
  (function(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest && e.target.closest('[data-scroll]');
      if (!btn) return;
      var name = btn.getAttribute('data-scroll');
      var el   = document.getElementById(name) ||
                 document.querySelector('.phpdev-' + name) ||
                 document.querySelector('.' + name);
      if (!el) return;
      var head = document.getElementById('hdr');
      var top  = el.getBoundingClientRect().top + window.pageYOffset -
                 (head ? head.offsetHeight : 0) - 12;
      window.scrollTo({top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth'});
    });
  })();



  /* шапка */
  var hdr = document.getElementById('hdr');
  var lastY = scrollY, acc = 0;
  if (hdr) addEventListener('scroll', function(){
    var y = scrollY, d = y - lastY;
    lastY = y;
    hdr.classList.toggle('stuck', y > 12);

    /* біля верху смужка завжди відкрита */
    if (y <= 90){ acc = 0; hdr.classList.remove('topbar-off'); return; }

    /* накопичуємо рух в один бік, зміна напрямку скидає лічильник — інакше
       інерційний відскок на кілька пікселів перемикав би смужку туди-сюди */
    acc = (d > 0) === (acc > 0) ? acc + d : d;

    if (acc > 40) hdr.classList.add('topbar-off');
    else if (acc < -30) hdr.classList.remove('topbar-off');
  }, {passive:true});

  /* поява при скролі */
  var rv = document.querySelectorAll('.rv');
  if (reduce) { rv.forEach(function(e){ e.classList.add('in'); }); }
  else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e, i){
        if (e.isIntersecting){
          setTimeout(function(){ e.target.classList.add('in'); }, Math.min(i * 70, 350));
          io.unobserve(e.target);
        }
      });
    }, {rootMargin:'0px 0px -12% 0px', threshold:.08});
    rv.forEach(function(e){ io.observe(e); });
  }

  /* прожектор під курсором */
  document.querySelectorAll('.spot').forEach(function(el){
    el.addEventListener('pointermove', function(e){
      var r = el.getBoundingClientRect();
      el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      el.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  });

  /* лічильники */
  var nums = document.querySelectorAll('.num[data-to]');
  var nio = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if (!e.isIntersecting) return;
      var el = e.target, to = +el.dataset.to, suf = el.dataset.suf || '', dec = +el.dataset.dec || 0;
      nio.unobserve(el);
      if (reduce){ el.textContent = fmt(to, dec) + suf; return; }
      var t0 = null, dur = 1400;
      requestAnimationFrame(function step(t){
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = Math.round(to * (1 - Math.pow(1 - p, 3)));
        el.textContent = fmt(v, dec) + suf;
        if (p < 1) requestAnimationFrame(step);
      });
    });
  }, {threshold:.4});
  function fmt(v, dec){
    if (dec) return (v / 10).toFixed(1).replace('.', ',');
    return v >= 1000 ? String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : String(v);
  }
  nums.forEach(function(n){ nio.observe(n); });

  /* мова сторінки: <html lang="en-US"> на англійській версії, "ru-RU" — на /ru/ (Polylang) */
  var en = /^en\b/i.test(document.documentElement.lang);
  var ru = /^ru\b/i.test(document.documentElement.lang);

  /* бігучі рядки */
  var dev = ['PHP 8.3','WordPress','ACF Pro','WooCommerce','MySQL / MariaDB','JavaScript','SCSS',
             'Gulp','REST API','Git','Composer','WP-CLI','Figma','Nginx'];
  var crm = ['KeyCRM','HubSpot','Pipedrive','Zoho CRM','Salesforce','Bitrix24','Google Sheets',
             'Zapier / Make','Telegram Bot API','Stripe','LiqPay / WayForPay',en ? 'Nova Poshta' : ru ? 'Новая Почта' : 'Нова Пошта','Mailchimp','GA4 / GTM'];
  var on = {'PHP 8.3':1,'WordPress':1,'ACF Pro':1,'WooCommerce':1,'KeyCRM':1,'HubSpot':1,'Pipedrive':1};
  function fill(id, list){
    var box = document.getElementById(id), html = '';
    if (!box) return;                      /* на внутрішніх сторінках бігучого рядка немає */
    for (var pass = 0; pass < 2; pass++)
      list.forEach(function(t){
        html += '<span class="chip' + (on[t] ? ' on' : '') + (pass ? ' dup' : '')
             + '" ' + (pass ? 'aria-hidden="true"' : '') + '>' + t + '</span>';
      });
    box.innerHTML = html;
  }
  fill('mq1', dev); fill('mq2', crm);

/* ---------- мобільне меню ---------- */
(function(){
    var burger = document.getElementById('burger'),
        drawer = document.getElementById('drawer'),
        back   = document.getElementById('drawerBack'),
        closeB = document.getElementById('drawerClose'),
        box    = document.getElementById('drawerNav');
    if (!burger || !drawer || !box) return;

    /* пункти клонуємо з десктопної навігації — один список на сторінку */
    document.querySelectorAll('nav.main a').forEach(function(a){
      box.appendChild(a.cloneNode(true));
    });

    /* парне значення до @media(max-width:991px) у base/header.scss — міняти разом */
    var open = false, last = null, wide = matchMedia('(min-width:992px)');

    function set(v){
      open = v;
      burger.setAttribute('aria-expanded', String(v));
      drawer.classList.toggle('on', v);
      drawer.setAttribute('aria-hidden', String(!v));
      document.body.classList.toggle('locked', v);
      if (v){
        last = document.activeElement;
        back.hidden = false;
        requestAnimationFrame(function(){ back.classList.add('on'); });
        var first = drawer.querySelector('a,button');
        if (first) first.focus();
      } else {
        back.classList.remove('on');
        setTimeout(function(){ if (!open) back.hidden = true; }, 350);
        if (last && last.focus) last.focus();
      }
    }

    burger.addEventListener('click', function(){ set(!open); });
    closeB.addEventListener('click', function(){ set(false); });
    back.addEventListener('click', function(){ set(false); });
    drawer.addEventListener('click', function(e){ if (e.target.closest('a')) set(false); });
    addEventListener('keydown', function(e){ if (e.key === 'Escape' && open) set(false); });
    wide.addEventListener('change', function(e){ if (e.matches && open) set(false); });
  })();

/* ---------- FAQ: плавне розкриття ---------- */
(function(){
    // Селектор по класу блока, а не по #faq: id секції задає редактор у панелі
    // Advanced і він може бути будь-яким або відсутнім.
    var items = document.querySelectorAll('.phpdev-faq details');
    if (!items.length || reduce) return;
    items.forEach(function(d){
      var sum = d.querySelector('summary'), anim = null;
      d.classList.add('faq-js');
      if (d.open) d.classList.add('is-open');
      sum.addEventListener('click', function(e){
        e.preventDefault();
        if (anim){ anim.cancel(); anim = null; }
        var opening = !d.open;
        var from = d.offsetHeight;
        d.classList.toggle('is-open', opening);
        if (opening) d.open = true;
        var to = opening ? d.offsetHeight : sum.offsetHeight;
        d.style.height = from + 'px';
        anim = d.animate({height:[from + 'px', to + 'px']},
                         {duration:300, easing:'ease-in-out'});
        anim.onfinish = function(){
          anim = null; d.style.height = '';
          if (!opening) d.open = false;
        };
        anim.oncancel = function(){ d.style.height = ''; };
      });
    });
  })();

  /* слайдер на Swiper */
  (function(){
    var el = document.getElementById('heroSwiper');
    if (!el || typeof Swiper === 'undefined') return;
    var count = document.getElementById('count');
    var total = ('0' + el.querySelectorAll('.swiper-slide').length).slice(-2);

    function setCount(sw){
      count.textContent = ('0' + (sw.realIndex + 1)).slice(-2) + ' / ' + total;
    }

    new Swiper(el, {
      speed: reduce ? 0 : 700,
      rewind: true,                 /* та сама поведінка, що була: з останнього — назад на перший */
      grabCursor: true,
      watchSlidesProgress: true,    /* дає .swiper-slide-visible для правила видимості вище */
      autoplay: reduce ? false : {delay: 7500, disableOnInteraction: false, pauseOnMouseEnter: true},
      navigation: {prevEl: '#prev', nextEl: '#next'},
      pagination: {
        el: '#dots', clickable: true,
        bulletClass: 'dot-btn', bulletActiveClass: 'is-on',
        renderBullet: function(index, className){
          return '<button type="button" class="' + className +
                 '" aria-label="' + (en ? 'Slide ' : 'Слайд ') + (index + 1) + '"></button>';
        }
      },
      a11y: en ? {prevSlideMessage: 'Previous slide', nextSlideMessage: 'Next slide'}
          : ru ? {prevSlideMessage: 'Предыдущий слайд', nextSlideMessage: 'Следующий слайд'}
               : {prevSlideMessage: 'Попередній слайд', nextSlideMessage: 'Наступний слайд'},
      on: {init: setCount, slideChange: setCount}
    });
  })();
})();

/* ---------------------------------------------------------------------------
 * Зовнішні посилання: href="#", адреса в data-href
 * ---------------------------------------------------------------------------
 * ГОЛОВНЕ ПРАВИЛО ПРОЄКТУ. Розмітку готує phpdev_link_atts() (incs/theme/helpers.php),
 * а відкриває адресу цей обробник — у новій вкладці.
 *
 * Слухаємо на document, а не на кожному посиланні: у темі є блоки, які
 * домальовують розмітку після завантаження (слайдери, фільтр робіт, превʼю в
 * редакторі), і навішувати обробник на елементи означало б губити ті, що
 * зʼявилися пізніше.
 *
 * Середній клік і Cmd/Ctrl+клік браузер обробляє сам ДО нашого коду і нічого
 * не відкриє, бо в href стоїть «#» — це прямий наслідок правила, не помилка.
 */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[data-href]') : null;
    if (!a) return;

    var url = a.getAttribute('data-href');
    if (!url) return;

    e.preventDefault();
    var win = window.open(url, '_blank', 'noopener');
    if (win) win.opener = null;      // страховка для старих рушіїв
  });
})();

/* Лейба «open to work» ховається, коли на екрані форма заявки — інакше на вузьких
   екранах вона перекриває поля й кнопку. Перенесено з концепту (brand/*.html) один
   в один: стилі .ribbon.hide у base/footer.scss були, а скрипта в темі не було.
   #lead — id глобального блока форми (template-parts/global/lead/block.php). */
(function(){
  var rb = document.querySelector('.ribbon'), lead = document.getElementById('lead');
  if (!rb || !lead || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(es){
    rb.classList.toggle('hide', es[0].isIntersecting);
  }, {threshold: .12}).observe(lead);
})();


/* Згода на cookies і GA4 (incs/theme/analytics.php). Там, де згода потрібна
   (ЄЕЗ, Велика Британія, Швейцарія — cfg.consent === true), gtag.js вантажимо лише
   після «Дозволити»: до згоди в Google не йде нічого. Поза цими країнами плашка сама
   не спливає, лічильник стартує одразу, а відмовитись можна кнопкою «Cookies» у
   підвалі. Вибір — у localStorage, бо сам банер cookies не ставить.
   window.phpdevGA немає — аналітика вимкнена для цього запиту (адмін, бриф). */
(function(){
  var cfg = window.phpdevGA, box = document.getElementById('consent');
  if (!cfg) return;
  var KEY = 'phpdev_consent', loaded = false;

  function read(){ try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function save(v){ try { localStorage.setItem(KEY, v); } catch (e) {} }

  function load(){
    if (loaded) return;
    loaded = true;
    gtag('consent', 'update', {analytics_storage: 'granted'});
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(cfg.id);
    document.head.appendChild(s);
    gtag('js', new Date());
    gtag('config', cfg.id);
  }
  function show(on){
    if (!box) return;
    box.hidden = !on;
    document.body.classList.toggle('consent-on', on);
  }

  /* cfg.consent === false — відвідувач поза ЄЕЗ/UK/CH (analytics.php): плашка сама
     не спливає і лічильник стартує одразу. Збережену відмову поважаємо й тут. */
  var choice = read();
  if (cfg.consent === false) {
    if (choice !== 'denied') load();
  } else {
    if (choice === 'granted') load();
    else if (choice !== 'denied') show(true);
  }

  /* Обробники потрібні в обох режимах: там, де згоди не питали, кнопка «Cookies»
     у підвалі і є способом відмовитись. */
  if (box) box.addEventListener('click', function(e){
    var b = e.target.closest('[data-consent]');
    if (!b) return;
    var v = b.getAttribute('data-consent');
    save(v);
    show(false);
    if (v === 'granted') load();
    // Відкликання: gtag уже завантажений — забороняємо зберігання до перезавантаження.
    else if (loaded) gtag('consent', 'update', {analytics_storage: 'denied'});
  });
  document.addEventListener('click', function(e){
    if (e.target.closest && e.target.closest('[data-consent-open]')) show(true);
  });

  /* події — лише якщо gtag уже працює (згода є) */
  function track(name, params){ if (loaded) gtag('event', name, params || {}); }

  document.addEventListener('phpdev:lead', function(e){
    track('generate_lead', {form_place: (e.detail && e.detail.place) || ''});
  });
  document.addEventListener('click', function(e){
    var a = e.target.closest ? e.target.closest('a[href], a[data-href]') : null;
    if (!a) return;
    var url = (a.getAttribute('data-href') || a.getAttribute('href') || '').toLowerCase(), m = '';
    if (url.indexOf('tel:') === 0) m = 'tel';
    else if (url.indexOf('mailto:') === 0) m = 'mailto';
    else if (url.indexOf('viber:') === 0) m = 'viber';
    else if (url.indexOf('tg:') === 0 || url.indexOf('t.me/') > -1) m = 'telegram';
    else if (url.indexOf('whatsapp:') === 0 || url.indexOf('wa.me/') > -1) m = 'whatsapp';
    if (m) track('contact_click', {method: m});
  });
})();
